import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Alert, Tag } from "antd";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectUserNumberById } from "src/store/callrecorder/userNumbersSlice";
import { fetchUserNumber } from "src/actions/callrecorder/userNumbersActions";
import { formattedDate } from "src/helpers/DateHelpers";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import Tabs from "src/componets/Tabs";
import SidebarShow from "./_partials/_SidebarShow";
import UserNumberSubscriptionsListTable from "../UserNumberSubscriptions/_partials/_ListTable";
import UserNumberMessagesConversation from "../UserNumberMessages/_partials/_Conversation";
import InvoicesListTable from "../Invoices/_partials/_ListTable";
import Icon from "src/componets/Icon";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const record = useAppSelector(state => id ? selectUserNumberById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchUserNumber(id));
    }
  }, [id, dispatch]);

  const filterParams = useMemo(() => ({ user_number_id: id }), [id]);

  return (
    <PageLayout className='v-user-numbers-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            record &&
              <SummaryShow
                icon={<Icon icon="fa-solid fa-phone" />}
                title={
                  <span>
                    {record.number || `User Number #${id}`}
                    {record.deleted && <Tag color="error" style={{ marginLeft: 8 }}>deleted</Tag>}
                  </span>
                }
                subtitle={record.friendly_name || record.number_type}
                createdAt={record.created_at}
                updatedAt={record.updated_at}
                className='v-mb-15'
              />
          }

          {
            record?.deleted &&
              <Alert
                type="warning"
                showIcon
                className='v-mb-15'
                message="This number was deleted by the user"
                description={record.deleted_at ? `Deleted on ${formattedDate(record.deleted_at).dateTime}. The history below is kept for reference.` : 'The history below is kept for reference.'}
              />
          }
        </div>

        <Tabs
          paramsKey='tab'
          defaultActiveKey='user_number_subscriptions'
          destroyInactiveTabPane={true}
          items={[
            { label: 'UN Subscriptions', key: 'user_number_subscriptions', children: <UserNumberSubscriptionsListTable filterParams={filterParams} /> },
            { label: 'Messages', key: 'user_number_messages', children: <UserNumberMessagesConversation userNumberId={id} /> },
            { label: 'Invoices', key: 'invoices', children: <InvoicesListTable filterParams={filterParams} /> },
          ]}
        />
      </div>

      <SidebarShow record={record} />
    </PageLayout>
  )
}

export default Show;
